import React from 'react';
import { Paper } from '@mui/material';
import anytrakkLogo from '../../assets/anytrakklogo.png'; 

const FooterLogo: React.FC = () => {
  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        p: 0, 
        bgcolor: '#ffffff',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    boxShadow: 'none'
      }} 
      elevation={8}
    >
      <img src={anytrakkLogo} alt="AnyTrakk" style={{ height: '80px', objectFit: 'contain' }} />
    </Paper>
  );
};

export default FooterLogo;